// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__IjYbr","box":"styles_box__p128j","icon":"styles_icon__ogngN"};